import { IzanagiMark } from "@/components/common/IzanagiMark";
import { IzanagiWordmark } from "@/components/common/IzanagiWordmark";

const LOGO_HEIGHT = 22;

/** サインイン・パスワード再設定・招待の受け入れ画面のカード上部のロゴ。 */
export function AuthLogo() {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: 11,
				height: 28,
				marginBottom: 4,
				color: "var(--brand-logo)",
			}}
		>
			<IzanagiMark height={LOGO_HEIGHT} />
			<IzanagiWordmark height={LOGO_HEIGHT} />
		</div>
	);
}
